import { useEffect, useState } from 'react';
import axios from "axios";
import ReactDOMServer from 'react-dom/server';
import { AppDatePicker, AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../routing/helpers/router';
import useIsMounted from '../../../../components/hooks/useIsMounted';

const Report20Options = (props) => {
  const {
    handleOnSetFieldValue,
    handleOnSubmit,
    handleOnSave,
    values,
    selectedReport,
  } = props;
  const isMounted = useIsMounted();
  const [reportOptions, setReportOptions] = useState();

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 20,
        selectedReport,
      })
      .then((r) => {
        if (isMounted.current) {
          setReportOptions(r.data);
        }
      })
      .catch(() => "");
  }, []);
  // < LOAD REPORT OPTIONS //

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <AppMultiSelect
            options={reportOptions?.categoryGroups || []}
            onChange={(e) => handleOnSetFieldValue('catGroups', e)}
            title={
              <Translator file="module-intelligence" name="category.groups" />
            }
            icon={<AppRemixIcon icon="apps" />}
            placeholder={ReactDOMServer.renderToString(
              <Translator file="module-intelligence" name="select.an.option" />
            )}
            value={values.catGroups || []}
            isLoading={!reportOptions?.categoryGroups}
            isMulti
            hasSearchBox
            hasSelectOptions
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-lawFinder"
                name="module.lf.filter.from"
              />
            }
            value={values.from}
            onChange={(date) => handleOnSetFieldValue('from', date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator file="module-lawFinder" name="module.lf.filter.to" />
            }
            value={values.to}
            onChange={(date) => handleOnSetFieldValue('to', date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={
                  !values.catGroups ||
                  values.catGroups.length === 0 ||
                  !values.to ||
                  !values.from
                }
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report20Options;
